<template>
  <div>
    <!-- Password Input -->
    <div class="col form-group">
      <input
        v-model="obj.password"
        id="password"
        class="w-100"
        :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
        :placeholder="translation.password"
        :type="showPassword ? 'text' : 'password'"
      />

      <span class="input-show-pass pt-2 mr-4" @click="showPassword = !showPassword">
        <i class="fa fa-eye senhaIcon" :class="showPassword ? 'fa-eye' : 'fa-eye-slash'" />
      </span>
    </div>

    <!-- Password Confirmation Input -->
    <div class="col form-group mt-5">
      <input
        id="confirmPassword"
        v-model="obj.confirmPassword"
        class="w-100"
        :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
        :placeholder="translation.repeatPassword"
        :type="showPassword2 ? 'text' : 'password'"
        @keyup.enter="validateFields"
      />

      <span class="input-show-pass pt-2 mr-4" @click="showPassword2 = !showPassword2">
        <i class="fa fa-eye repsenhaIcon" :class="showPassword2 ? 'fa-eye' : 'fa-eye-slash'" />
      </span>
    </div>

    <p class="pl-3" style="font-size: 0.7rem">
      <small :style="template.secondaryTheme ? 'color: white;' : ''"
        >* {{ translation.minimumCharacterPass }}</small
      >

      <br />

      <small :style="template.secondaryTheme ? 'color: white;' : ''"
        >* {{ translation.specialCharacter }}</small
      ><br />

      <small :style="template.secondaryTheme ? 'color: white;' : ''"
        >* {{ translation.oneNumber }}</small
      >
    </p>
  </div>
</template>

<script>
/* State */
import { mapState, mapMutations } from 'vuex'

/* Helpers */
import { mask } from 'vue-the-mask'

export default {
  name: 'GenderAndBirthDate',
  mask: {
    ...mask,
    tokens: {
      ...mask.tokens,
      null: /./,
    },
  },
  props: {
    validate: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    obj: {},
    showPassword: false,
    showPassword2: false,
  }),
  computed: {
    ...mapState(['config', 'registrationObject', 'subdomain', 'template']),
    translation() {
      if (this.obj.passport) {
        return {
          password: 'Password',
          repeatPassword: 'Repeat Password',
          minimumCharacterPass: 'At least 8 characters.',
          specialCharacter: 'At least 1 special character.',
          oneNumber: 'At least 1 number.',
          error: {
            requiredPass: 'A password is required.',
            minimumCharacterPass: 'Password must contain at least 8 characters.',
            specialCharacter: 'Password must contain at least 1 special character.',
            oneNumber: 'Password must contain at least 1 number.',
            differentPass: 'The passwords provided are different.',
          },
        }
      }
      return {
        password: 'Senha',
        repeatPassword: 'Repetir Senha',
        minimumCharacterPass: 'Pelo menos 8 caracteres.',
        specialCharacter: 'Pelo menos 1 caractere especial.',
        oneNumber: 'Pelo menos 1 número.',
        errors: {
          requiredPass: 'É necessário informar uma senha.',
          minimumCharacterPass: 'A senha precisa conter pelo menos 8 caracteres.',
          specialCharacter: 'A senha precisa conter pelo menos 1 caractere especial.',
          oneNumber: 'A senha precisa conter pelo menos 1 número.',
          differentPass: 'As senhas informadas são diferentes.',
        },
      }
    },
  },
  watch: {
    validate(newValue) {
      if (newValue) this.validateFields()
    },
  },
  methods: {
    ...mapMutations([
      'addRegistrationError',
      'clearRegistrationErrors',
      'updateRegistrationObject',
    ]),
    validateFields() {
      this.$emit('validating')

      this.clearRegistrationErrors()

      let hasErrors = false

      if (!this.obj.password) {
        hasErrors = true

        this.addRegistrationError({
          msg: this.translation.error.requiredPass,
        })
      }

      if (this.obj.password.length < 8) {
        hasErrors = true

        this.addRegistrationError({
          msg: this.translation.error.minimumCharacterPass,
        })
      }

      if (!this.containsNumbers(this.obj.password)) {
        hasErrors = true

        this.addRegistrationError({
          msg: this.translation.error.oneNumber,
        })
      }

      if (!this.containsSpecialCharacters(this.obj.password)) {
        hasErrors = true

        this.addRegistrationError({
          msg: this.translation.error.specialCharacter,
        })
      }

      if (this.obj.password != this.obj.confirmPassword) {
        hasErrors = true

        this.addRegistrationError({
          msg: this.translation.error.differentPass,
        })
      }

      if (!hasErrors) {
        this.$store.commit('updateRegistrationObject', this.obj)

        this.$emit('next')
      }
    },
    containsNumbers(str) {
      return /[0-9]/.test(str)
    },
    containsSpecialCharacters(str) {
      // eslint-disable-next-line no-useless-escape
      const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/

      return specialChars.test(str)
    },
  },
  mounted() {
    // Create a deep copy of the object in the store
    this.obj = JSON.parse(JSON.stringify(this.registrationObject))

    document.getElementById('password').focus()
  },
}
</script>
